import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './styles.css';
import bgParticular from '../../assets/backgrounds/particular.jpg';
import bgProfissional from '../../assets/tipos/condominio.png';
import { useGlobalState } from '../../contexts/GlobalStateContext';

const AgentSection = () => {
  const { t } = useTranslation();
  const [isSpecial, setIsSpecial] = useState(false);
  const [showContent, setShowContent] = useState(false);
  const { handleOpenLogin } = useGlobalState();
  const navigate = useNavigate();
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
          setShowContent(true);
        }
      },
      { threshold: 0.1 }
    );

    const currentRef = sectionRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  const toggleView = () => {
    setShowContent(false);
    setTimeout(() => {
      setIsSpecial(!isSpecial);
      setTimeout(() => {
        setShowContent(true);
      }, 50);
    }, 500);
  };

  const handleRegister = () => {
    // Particular -> /cadastro/hostd?perfil=particular ; Profissional -> /cadastro/hostd?perfil=profissional
    if (isSpecial) {
      navigate('/cadastro/hostd?perfil=particular');
    } else {
      navigate('/cadastro/hostd?perfil=profissional');
    }
  };

  return (
    <section 
      className={`agent-section ${isSpecial ? 'special' : ''}`} 
      ref={sectionRef}
      style={{
        backgroundImage: `url(${isSpecial ? bgParticular : bgProfissional})`
      }}
    >
      <div className="agent-overlay"></div>
      <div className={`agent-content ${showContent ? 'show' : ''}`}>
        <div className={`agent-text ${showContent ? 'show' : ''}`}>
          <h2>
            <span>{isSpecial ? t('agent.individual') : t('agent.professional')}</span>
            <span className="highlight">
              {isSpecial ? t('agent.ownerQuestion') : t('agent.agencyTitle')}
            </span>
          </h2>
          <p>
            {isSpecial 
              ? t('agent.ownerDescription')
              : t('agent.agencyDescription')}
          </p>
        </div>
        <div className={`agent-buttons ${showContent ? 'show' : ''}`}>
          <button className="btn-registration" onClick={handleRegister}>{t('agent.register')}</button>
          <button className="btn-login" onClick={handleOpenLogin}>{t('agent.login')}</button>
        </div>
        {/* Botão de alternância dentro da caixa branca, canto inferior direito */}
        <button 
          className={`btn-individuals agent-cta-toggle ${isSpecial ? 'special' : ''} ${showContent ? 'show' : ''}`} 
          onClick={toggleView}
          aria-label={isSpecial ? t('agent.viewProfessional') : t('agent.viewIndividuals')}
        >
          {isSpecial ? t('agent.professionalButton') : t('agent.individualsButton')}
        </button>
      </div>
    </section>
  );
};

export default AgentSection;